import { Injectable, EventEmitter } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DeliveryClosureService {
  $selectedPharmacy = new EventEmitter();

  constructor() {}

  selectedPharmacy(index) {
    this.$selectedPharmacy.emit(index);
  }
}
